export const CalendarViewModes = {
	MONTH: 'month',
	WEEK: 'week'
}